import { getContractDetailsEndpoint } from './contracts';

export function getPaymentDetailsEndpoint(contractId: string): string {
    return `${getContractDetailsEndpoint(contractId)}/payment-details`;
}

export function getGeneratePaymentEndpoint(contractId: string): string {
    return `${getContractDetailsEndpoint(contractId)}/generate-payment`;
}
